import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import UserForm from "../user/UserForm";
import PasswordResetEmailModal from "../user/PasswordResetEmailModal";
import './User.css';
import SetPasswordModal from "./SetPasswordModal";
import PassiveMemberInformModal from "./PassiveMemberInformModal";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";

class UserList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedUser: null,
            selectedItem: null,
            branches: null,
            groups: null,
            roles: null,
            aliasList: null,
            users: [],
            cities: this.props.location.cities,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addUserModal: false,
            addPasswordResetModal: false,
            passiveMemberInformModal: false,
        };

        this.listUsers = this.listUsers.bind(this);
        this.cancelUserCreation = this.cancelUserCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.listGroups = this.listGroups.bind(this);
        this.listRoles = this.listRoles.bind(this);
        this.handleSendResetPasswordEmail = this.handleSendResetPasswordEmail.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleSetPassword = this.handleSetPassword.bind(this);

    }

    componentDidMount() {
        this.listBranches();
        this.listGroups();
        this.listRoles();
    }

    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/oda/oda-list/",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let branches = response.data;
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listGroups() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/group/select",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let groups = response.data;
                self.setState({
                    groups,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    listRoles() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/roles/select",
            method: "get",
        };
        request(params)
            .then(function (response) {
                // Gelen cevabı uygun formata dönüştür
                let roles = response.data.map(role => ({ id: role.value, name: role.label }));
                console.log("Roles:", roles); 
                self.setState({
                    roles,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    
    


    listUsers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=recordId,asc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/user/all-users-with-roles?page=" + page + "&size=" + size + sortStr + searchQuery;

        let params = {
            url: url,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let users = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    users,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    
    

    cancelUserCreation() {
        this.setState({
            addUserModal: false,
            addPasswordResetModal: false,
            passiveMemberInformModal: false,
            selectedUser: null,
        })
    }    
   
    handleEdit(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/id/" + item.recordId,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedUser: response.data,
                addUserModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }
    
    
    handleSetPassword(item) {
        let self = this;
        self.setState({
            selectedUser: item,
            setPasswordModal: true
        })

    }

    handleSendResetPasswordEmail(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/id/" + item.recordId,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedUser: response.data,
                addPasswordResetModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSendPassiveInformEmail(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/id/" + item.recordId,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedUser: response.data,
                passiveMemberInformModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    addNew() {
        let self = this;
        self.setState({
            selectedUser: null,
            addUserModal: true
        })
    }


    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.listUsers(this.state.accessor, this.state.direction, 0, this.state.size))
    }


    handleLogout() {
        this.props.handleLogout();
    }


    render() {
        let self = this;
        const {users} = this.state;
        const {branches} = this.state;
        const{roles}=this.state;
        let selectdata;
        
        const header = [
            {value: null, label: "Tümü"},
        ];
        branches ? selectdata = header.concat(branches) : selectdata = header;
    
       // const roleSelectData = roles ? [{ value: null, label: "Tümü" }].concat(roles) : [];
        const roleSelectData = this.state.roles ? [{ value: null, label: "Tümü" }].concat(this.state.roles.map(role => ({ value: role.id, label: role.name }))) : [];


    
        const menu = (
            <Menu>
                <Menu.Item key="1" onClick={() => this.handleEdit(self.state.selectedItem)}>
                    Kullanıcı Düzenle
                </Menu.Item>

                <Menu.Item key="2" onClick={() => this.handleSendResetPasswordEmail(self.state.selectedItem)}>
                Şifre Sıfırlama E-postası Gönder
                </Menu.Item>

                <Menu.Item key="3" onClick={() => this.handleSendPassiveInformEmail(self.state.selectedItem)}>
                    Üyelik Pasife Alma E-postası Gönder
                </Menu.Item>

                <Menu.Item key="4"  onClick={() => this.handleSetPassword(self.state.selectedItem)}>
                    Şifre Düzenle
                </Menu.Item>
            </Menu>
        );
        const columns = [
            {
                Header: "Adı",
                accessor: "name",
            },
            {
                Header: "Soyadı",
                accessor: "surname",
            },
            {
                Header: "Kullanıcı Adı",
                accessor: "username",
            },
            {
                Header: "E-posta",
                accessor: "email",
            },
            {
                Header: "Rolü",
                accessor: "roles",
            },
        ];

        // if (this.props.currentUser.realm === 0) {
        //     columns.push({
        //         Header: "Oda",
        //         accessor: "",
        //         Cell: item => (
        //             // <label>{branches && item.odaId && branches[item.odaId - 1].label}</label>
        //                 <label>{branches && item.odaId && branches[0] && branches[0].label}</label>
        // )
        //     });
        // }
        columns.push(
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu}
                                  trigger='click'
                                  onClick={() => self.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            });

      

        const fields = [
            {
                label: "Adı",
                accessor: "name",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyadı",
                accessor: "surname",
                type: "text",
                operator: "=",
            },
            {
                label: "Kullanıcı Adı",
                accessor: "username",
                type: "text",
                operator: "=",
            },
            // {
            //     label: "Oda",
            //     accessor: "odaId",
            //     type: "select",
            //     operator: "=",
            //     selectData: selectdata,
            // },
            {
                label: "Rolü",
                accessor: "roleId",
                type: "select",
                operator: "=",
                selectData: roleSelectData,
            },
   
            {
                label: "E-posta",
                accessor: "email",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="row baseBackground">
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Kullanıcı Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={users}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listUsers}
                            style={{width:"100%"}}
                        />
                    </div>
                    {
                        (this.state.mode !== 'review') &&
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Yeni Kullanıcı Ekle" disabled={this.state.isLoading}
                                    style={{
                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                        height: '40px',
                                        width: '180px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                    }}
                                    className="TekBtn add-new-member "
                                    rel="tooltip"
                                    onClick={() => this.addNew(this.state.selectedItem)}
                                    // onClick={() => this.addNew()}
                                    >
                                YENİ KULLANICI EKLE
                            </button>
                    }
                </div>

                <Modal isOpen={this.state.addUserModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelUserCreation}>
                        {this.state.selectedUser ? "Kullanıcı Düzenleme Ekranı" :"Yeni Kullanıcı Ekle Ekranı"}
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <UserForm cancelProcess={this.cancelUserCreation} selectedUser={this.state.selectedUser}
                                  mode={this.state.mode}
                                  module={this.props.name} groups={this.state.groups} 
                                  handleSearch={this.handleSearch}
                                  searchQuery={this.state.searchQuery}
                                  branches={this.state.branches} 
                                  roles={this.state.roles}
                                  handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
                <Modal isOpen={this.state.addPasswordResetModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelUserCreation}>
                        Şifre Sıfırlama E-postası
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <PasswordResetEmailModal cancelProcess={this.cancelUserCreation}
                                                 selectedUserName={this.state.selectedUser && this.state.selectedUser.name}
                                                 selectedUserSurname={this.state.selectedUser && this.state.selectedUser.surname}
                                                 selectedUserEmail={this.state.selectedUser && this.state.selectedUser.email}
                                                 handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
                <Modal isOpen={this.state.passiveMemberInformModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelUserCreation}>
                        Üye Pasife Alma Bildirim E-postası
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <PassiveMemberInformModal cancelProcess={this.cancelUserCreation}
                                                  selectedUserName={this.state.selectedUser && this.state.selectedUser.name}
                                                  selectedUserSurname={this.state.selectedUser && this.state.selectedUser.surname}
                                                  selectedUserEmail={this.state.selectedUser && this.state.selectedUser.email}
                                                  handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
                <Modal isOpen={this.state.setPasswordModal} size="lg" className="ust">
                    <ModalHeader toggle={() => this.setState({setPasswordModal: false})}>
                        Yeni Şifre Giriniz
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <SetPasswordModal cancelProcess={() => this.setState({setPasswordModal: false})}
                                          selectedUser={this.state.selectedUser}/>
                    </ModalBody>
                    }
                </Modal>


            </div>
        )
    }
}

export default UserList



// WEBPACK FOOTER //
// ./src/page/user/UserList.js